import { combineReducers } from 'redux'
import { IPagination } from '../../../types/pagination'
import { IProjectInvoice } from '../../project/types/invoice'
import { IDirectCostInvoice } from './../../project/types/invoice'
import { IAccountingChartData, IPeriodType } from './../types/accounting'
import {
  accountingChartData,
  accountingReceiptsChartData,
  invoiceYears,
  paginatedDCInvoiceActivePage,
  paginatedDCInvoices,
  paginatedInvoiceActivePage,
  paginatedInvoices,
  periodType,
  selectedDCInvoice,
  selectedInvoice,
  selectedTab,
  selectedYear
} from './accounting'

export interface AccountingState {
  paginatedInvoices: IPagination<IProjectInvoice[]>
  paginatedInvoiceActivePage: number
  selectedInvoice: IProjectInvoice
  accountingChartData: IAccountingChartData
  paginatedDCInvoices: IPagination<IDirectCostInvoice[]>
  paginatedDCInvoiceActivePage: number
  selectedDCInvoice: IDirectCostInvoice
  accountingReceiptsChartData: IAccountingChartData
  periodType: IPeriodType
  selectedYear: number
  selectedTab: string
  invoiceYears: number[]
}

const accountingApp = combineReducers<AccountingState>({
  paginatedInvoices,
  paginatedInvoiceActivePage,
  selectedInvoice,
  accountingChartData,
  paginatedDCInvoices,
  paginatedDCInvoiceActivePage,
  selectedDCInvoice,
  accountingReceiptsChartData,
  periodType,
  selectedYear,
  selectedTab,
  invoiceYears
})

export default accountingApp
